import { render, staticRenderFns } from "./AudioTranscriptionRecorder.vue?vue&type=template&id=3a677f46&scoped=true&"
import script from "./AudioTranscriptionRecorder.vue?vue&type=script&lang=js&"
export * from "./AudioTranscriptionRecorder.vue?vue&type=script&lang=js&"
import style0 from "./AudioTranscriptionRecorder.vue?vue&type=style&index=0&id=3a677f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a677f46",
  null
  
)

export default component.exports